import { onMounted, onBeforeUnmount, ref } from '@vue/composition-api';

const userHasInteracted = ref(false);

const setUserInteraction = () => {
  userHasInteracted.value = true;
  window.removeEventListener('scroll', setUserInteraction);
  window.removeEventListener('click', setUserInteraction);
  window.removeEventListener('touchstart', setUserInteraction);
};

export default () => {
  onMounted(() => {
    window.addEventListener('scroll', setUserInteraction);
    window.addEventListener('click', setUserInteraction);
    window.addEventListener('touchstart', setUserInteraction);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', setUserInteraction);
    window.removeEventListener('click', setUserInteraction);
    window.removeEventListener('touchstart', setUserInteraction);
  });

  return { userHasInteracted };
};
